<template>
    <ErrorPage>
        <template slot="Title">
            This looks empty
        </template>
        <template slot="SubTitle">
        </template>
        <template slot="Content">
            Try creating your first template then drag a clock in it!
        </template>
        <template slot="Actions">
            <Button @click="onCreateDTClicked" :empty="false">Create new DT</Button>
        </template>
    </ErrorPage>
</template>

<script>
    import Button from'@/components/common/Button.vue'
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import EventBus from '@/eventbus';
    export default {
        name: "DayTemplateListEmptyCard",
        components: {
            Button, ErrorPage
        },
        methods: {
            onCreateDTClicked() { EventBus.$emit('onDayTemplateCreation'); }
        }
    }
</script>

<style scoped>
</style>